export enum HttpResponseStatusCodes {
  InternalServerError = 500
}
